(function () {
  'use strict';

  // Respeita preferência do usuário por menos movimento
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  var EASE_DELAY = 60; // ms entre cada card no stagger

  // ── Intersection Observer ──────────────────────────────────
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var el = entry.target;
        el.classList.add('is-visible');
        observer.unobserve(el);
        // Limpa o stagger delay após o reveal concluir para que
        // o hover não sofra atraso desnecessário
        var staggerDelay = parseFloat(el.style.transitionDelay) || 0;
        setTimeout(function () {
          el.style.transitionDelay = '0ms';
        }, staggerDelay + 700); // 700ms = duração (0.6s) + margem
      }
    });
  }, {
    threshold: 0.08,
    rootMargin: '0px 0px -40px 0px'
  });

  function observe(el) {
    observer.observe(el);
  }

  function addAnim(el, type, delayMs) {
    el.classList.add('innova-anim');
    if (type) el.classList.add('innova-anim--' + type);
    if (delayMs) el.style.transitionDelay = delayMs + 'ms';
    observe(el);
  }

  // ── Stagger helper ─────────────────────────────────────────
  function stagger(selector, type, baseDelay, maxItems) {
    var items = document.querySelectorAll(selector);
    var limit = maxItems || items.length;
    var groupStart = {}; // controla delay por grupo (lista pai)

    items.forEach(function (el, i) {
      // Reseta delay por seção para não acumular em muitos cards
      var parent = el.closest('.product-list, .collection-list, .block-list, .innova-collage__right, .innova-collage__small-row, .innova-collage__featured');
      var key = parent ? parent : 'global';
      if (groupStart[key] === undefined) groupStart[key] = 0;
      var delay = baseDelay * groupStart[key];
      if (groupStart[key] < (maxItems || 8)) groupStart[key]++;

      addAnim(el, type, delay);
    });
  }

  // ── Init após DOM + imagens parcialmente carregadas ────────
  function init() {
    // Section headers — fade up
    document.querySelectorAll('.section__header').forEach(function (el) {
      addAnim(el, 'up', 0);
    });

    // Product cards — fade up com stagger por lista
    stagger('.product-list .product-item--vertical', 'up', EASE_DELAY, 8);

    // Collection items — scale com stagger
    stagger('.collection-list .collection-item', 'scale', 50, 10);

    // Promo blocks — fade up com stagger
    stagger('.block-list__item .promo-block', 'up', 80, 6);

    // Collage items — fade up com stagger
    stagger('.innova-collage-item', 'up', 100, 5);

    // Image with text sections
    document.querySelectorAll('[data-section-type="image-with-text"]').forEach(function (el) {
      addAnim(el.querySelector('.container'), 'up', 0);
    });

    // Collection with image
    document.querySelectorAll('[data-section-type="collection-with-image"]').forEach(function (el) {
      addAnim(el.querySelector('.container'), 'up', 0);
    });
  }

  // ── Barra laranja do título cresce no reveal ───────────────
  // O observer do CSS usa .section__header.is-visible — funciona via cascade
  // Mas precisamos garantir que o after seja animado quando o header fica visível

  // ── Slideshow: animação de entrada do conteúdo ─────────────
  function animateSlideshow() {
    var slideshow = document.querySelector('[data-section-type="slideshow"]');
    if (!slideshow) return;

    var title   = slideshow.querySelector('.slideshow__title');
    var content = slideshow.querySelector('.slideshow__content');
    var button  = slideshow.querySelector('.slideshow__button');

    [title, content, button].forEach(function (el, i) {
      if (!el) return;
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.7s ease ' + (i * 150 + 200) + 'ms, transform 0.7s ease ' + (i * 150 + 200) + 'ms';
      setTimeout(function () {
        el.style.opacity = '';
        el.style.transform = '';
      }, 50);
    });
  }

  // ── Hover: barra de progresso no section__title ────────────
  // Já controlada via CSS: .innova-anim.is-visible .section__title::after { width: 36px }

  // ── Execução ───────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      animateSlideshow();
    });
  } else {
    init();
    animateSlideshow();
  }

}());
